import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`You don't need to learn Rust to enjoy its benefits (fast & secure flavor). This post is ads of the tools written by Rust and I enjoy using so far!`}</p>
    <p>{`When I'm done with the list, I found a similar yet better post for this modern rust CLI revolution. Please visit `}<a parentName="p" {...{
        "href": "https://zaiste.net/posts/shell-commands-rust/"
      }}>{`here`}</a></p>
    <h1>{`Ads😉`}</h1>
    <ul>
      <li parentName="ul"><strong parentName="li">{`RipGrep`}</strong>{`: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`grep`}</code>{` < `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`ag`}</code>{` < `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`rg`}</code>{`. Fast fast fast and `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`-uuu`}</code>{`!`}</li>
      <li parentName="ul"><strong parentName="li">{`Fd`}</strong>{`: replacement of find. Fast and colorful!`}</li>
      <li parentName="ul"><strong parentName="li">{`Exa`}</strong>{`: replacement for ls and colorful!`}</li>
      <li parentName="ul"><strong parentName="li">{`Zoxide`}</strong>{`: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`j/autojump`}</code>{` < `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`z/fasd`}</code>{` < `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`zoxide`}</code></li>
      <li parentName="ul"><strong parentName="li">{`Skim`}</strong>{`: fzf competitor. or go vs rust😄. who is faster and who is more secure. interesting!`}</li>
      <li parentName="ul"><strong parentName="li">{`Tickrs`}</strong>{`: fast ticker for market watch`}</li>
      <li parentName="ul"><strong parentName="li">{`Dust`}</strong>{`: faster, safer du`}</li>
      <li parentName="ul"><strong parentName="li">{`Duf`}</strong>{`: df replacement`}</li>
      <li parentName="ul"><strong parentName="li">{`Miniserve`}</strong>{`: faster, safer folder server`}</li>
    </ul>
    <p>{`Last ads about OS: Redox, a crazy idea and a lot of work to do but I'd like to try if released...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      